import {
  Text,
  getCasinoCategoryIcon,
  ArrowSvg,
  useZustandModalKitStore,
  zustandModalKitSelector,
  EModalTypes,
} from 'react-gldn-kit';

import styles from './ProviderRowHeader.module.css';

type Props = {
  categoryName: string;
};

const CasinoHomeRowHeader = ({ categoryName }: Props) => {
  const setModal = useZustandModalKitStore(
    zustandModalKitSelector.setModalInfoAction
  );

  const jumpTo = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setModal(EModalTypes.CasinoProviders);
  };

  const Icon = getCasinoCategoryIcon(100);

  return (
    <div className={styles.categoryHeaderWrapper}>
      <div className={styles.leftInfo}>
        {Icon && <Icon classes={styles.categoryIcon} />}

        <div className={styles.categoryName}>
          <Text idT={categoryName} />
        </div>
      </div>

      <div className={styles.showAllBtn} onClick={jumpTo}>
        <div>
          <Text idT="showMoreBtn" />
        </div>

        <ArrowSvg classes={styles.arrowMore} />
      </div>
    </div>
  );
};

export default CasinoHomeRowHeader;
